import React, { FunctionComponent, Fragment } from 'react';
import classNames from 'classnames';

type TitleProps = {
    titleText: string;
    respondent?: { name: string };
    registrant?: { name: string };
    isCustomHeaderTitle?: boolean;
    titleHeading?: string;
};

const Title: FunctionComponent<TitleProps> = (props) => {
    const headerStyle = classNames({
        'header-title': true,
        'custom-title': !!props.isCustomHeaderTitle,
    });

    return (
        <div className={headerStyle}>
            {props.titleText}
            {props.titleHeading && (
                <Fragment>
                    <div className="custom-header">{props.titleHeading}</div>
                </Fragment>
            )}
            {props.respondent && props.registrant && (
                <Fragment>
                    <br />
                    <div className="header-sub-title">
                        <b>Respondent</b>: {props.respondent.name}
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <b>Registrant</b>: {props.registrant.name}
                    </div>
                </Fragment>
            )}
        </div>
    );
};

export default Title;
